import { LANG, VAR_TYPES } from "constants/constants";
import { FormattedMessage } from "react-intl";

export const branchForm = ({
  branches,
  personsByProfileList,
  staffList,
  regionList,
  countryList,
  typeCompaniesList,
  templateList,
  lang,
}) => {
  return [
    { col: "name", mandatory: true, isMissingValue: null },
    { col: "domain_name", mandatory: true, isMissingValue: null },
    {
      col: "subsidiary_id",
      isMissingValue: null,
      editable: true,
      popup: {
        title: {
          id: "admin_country_page_table_name_branch_search",
          defaultMessage: "Recherche et sélectionne une filiale",
        },
      },
      mandatory: false,
      type: VAR_TYPES.DROPDOWN,
      choices: [{ name: "", value: null }].concat(
        branches?.map((elm) => ({ name: elm.name, value: elm.id }))
      ),
    },
    { col: "phone_number", mandatory: true, isMissingValue: null },
    {
      col: "director_id",
      isMissingValue: null,
      editable: true,
      popup: {
        title: {
          id: "admin_country_page_table_name_dsoc_search",
          defaultMessage: "Rechercher et sélectionner un responsable",
        },
      },
      mandatory: true,
      type: VAR_TYPES.SEARCH,
      choices: personsByProfileList
        .filter((elm) => elm.profile_id === "dsoc")
        ?.map((elm) => ({
          value: elm?.id,
          label: `${elm?.first_name} ${elm?.last_name}`,
        })),
      search: true,
    },
    { col: "director_title", mandatory: true, isMissingValue: null },
    {
      col: "rgp_id",
      isMissingValue: null,
      editable: true,
      popup: {
        title: {
          id: "admin_country_page_table_name_rgp_search",
          defaultMessage: "Recherche et sélectionne une devise",
        },
      },
      mandatory: true,
      type: VAR_TYPES.SEARCH,
      choices: personsByProfileList
        .filter((elm) => elm.profile_id === "rgp" || elm.profile_id === "gp")
        ?.map((elm) => ({
          value: elm?.id,
          label: `${elm?.first_name} ${elm?.last_name}`,
        })),
      search: true,
    },
    { col: "insee_code", mandatory: false, isMissingValue: null },
    {
      col: "capital",
      mandatory: false,
      isMissingValue: null,
      type: VAR_TYPES.NUMBER,
    },
    { col: "machine_name", mandatory: true, isMissingValue: null },
    {
      col: "region",
      mandatory: true,
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.TAGS,
      popup: {
        title: {
          id: "admin_country_page_table_name_region_search",
          defaultMessage: "Recherche et sélectionne une ou plusieurs régions",
        },
      },
      choices: regionList?.map((elm) => ({
        label: elm.name,
        value: elm.id,
      })),
    },
    { col: "address", mandatory: true, isMissingValue: null },
    { col: "address_city", mandatory: true, isMissingValue: null },
    { col: "address_postal_code", mandatory: true, isMissingValue: null },
    {
      col: "country_id",
      mandatory: true,
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: [{ name: "", value: null }].concat(
        countryList.map((e) => ({
          name: e.name,
          value: e.id.toString(),
        }))
      ),
    },
    {
      col: "legal_form",
      isMissingValue: null,
      editable: true,
      popup: {
        title: {
          id: "admin_country_page_table_legal_form_search",
          defaultMessage: "Recherche et sélectionne une filiale",
        },
      },
      mandatory: false,
      type: VAR_TYPES.SEARCH,
      choices: typeCompaniesList.map((elm) => ({
        label: lang === LANG.FR ? elm.fr : elm.en,
        value: elm.id,
      })),
    },
    { col: "rcs", mandatory: false, isMissingValue: null },
    {
      col: "minimum_salary",
      mandatory: true,
      isMissingValue: null,
      type: VAR_TYPES.NUMBER,
    },
    {
      col: "template_id",
      mandatory: true,
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: [{ name: "", value: null }].concat(
        templateList.map((e) => ({
          name: e.title,
          value: e.id.toString(),
        }))
      ),
    },
    {
      col: "associates",
      isMissingValue: null,
      editable: true,
      popup: {
        title: {
          id: "admin_country_page_table_associates_search",
          defaultMessage: "Recherche et sélectionne des associés",
        },
      },
      mandatory: false,
      type: VAR_TYPES.TAGS,
      choices: staffList?.map((elm) => ({
        value: elm?.id,
        label: `${elm?.first_name} ${elm?.last_name}`,
      })),
      search: true,
    },
    {
      col: "signature_file",
      mandatory: false,
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.FILE,
    },
    {
      col: "sustainable_mobility_package",
      mandatory: false,
      editable: true,
      isMissingValue: false,
      type: VAR_TYPES.DROPDOWN,
      choices: [
        {
          name: <FormattedMessage id={"no"} defaultMessage={"Non"} />,
          value: false,
        },
        {
          name: <FormattedMessage id={"yes"} defaultMessage={"Oui"} />,
          value: true,
        },
      ],
    },
  ];
};

export const formatPayload = (payload) => ({
  ...payload,
  country_id: Number(payload?.country_id),
  director_id: payload?.director_id[0]?.value,
  rgp_id: payload?.rgp_id[0]?.value || null,
  associates: payload?.associates?.map((elm) => elm.value) || [],
  subsidiary_id: isNaN(Number(payload?.subsidiary_id))
    ? []
    : [Number(payload?.subsidiary_id)],
  legal_form: payload?.legal_form ? payload?.legal_form[0]?.value : null,
  template_id: Number(payload.template_id),
  sustainable_mobility_package:
    payload?.sustainable_mobility_package === "true",
  signature_file: null,
  region: payload?.region?.map((elm) => elm.value),
  capital: payload?.capital || null,
  rcs: payload?.rcs || null,
  parent_branch: Number(payload?.subsidiary_id) || null,
});

export const formatReceivedBranch = ({
  branch,
  branches,
  personsList,
  typeCompaniesList,
  lang,
  regionList,
  staffList,
}) => ({
  ...branch,
  region:
    branch?.region &&
    regionList
      ?.filter((elm) => branch?.region.includes(elm.id))
      .map((elm) => ({ label: elm.name, value: elm.id })),
  subsidiary_id: branches
    .filter((elm) => branch?.subsidiary_id?.toString() == elm.id)
    .map((elm) => elm?.id),
  director_id: personsList
    .filter((elm) => elm.id === branch?.director_id)
    ?.map((elm) => ({
      value: elm?.id,
      label: `${elm?.first_name} ${elm?.last_name}`,
    })),
  rgp_id: personsList
    .filter((elm) => elm.id === branch?.rgp_id)
    ?.map((elm) => ({
      value: elm?.id,
      label: `${elm?.first_name} ${elm?.last_name}`,
    })),
  associates: staffList
    .filter((elm) => branch?.associates?.includes(elm.id))
    ?.map((elm) => ({
      value: elm?.id,
      label: `${elm?.first_name} ${elm?.last_name}`,
    })),
  legal_form: typeCompaniesList
    .filter((elm) => elm.id === branch?.legal_form)
    ?.map((elm) => ({
      value: elm?.id,
      label: lang === LANG.FR ? elm.fr : elm.en,
    })),
});

export const formatDisplayBranch = ({
  branch,
  branches,
  personsList,
  typeCompaniesList,
  lang,
  regionList,
  staffList,
  countryList,
}) => ({
  ...branch,
  region:
    branch?.region &&
    regionList
      ?.filter((elm) => branch?.region.includes(elm.id))
      .map((elm) => elm.name)
      .join(", "),
  subsidiary_id:
    branches &&
    branches
      .filter((elm) => branch?.subsidiary_id?.includes(elm.id))
      .map((elm) => elm.name)
      .join(", "),
  director_id: personsList
    .filter((elm) => elm.id === branch?.director_id)
    ?.map((elm) => `${elm?.first_name} ${elm?.last_name}`)[0],
  rgp_id: personsList
    .filter((elm) => elm.id === branch?.rgp_id)
    ?.map((elm) => `${elm?.first_name} ${elm?.last_name}`)[0],
  associates: staffList
    .filter((elm) => branch?.associates?.includes(elm.id))
    ?.map((elm) => `${elm?.first_name} ${elm?.last_name}`)
    .join(", "),
  legal_form: typeCompaniesList
    .filter((elm) => elm.id === branch?.legal_form)
    ?.map((elm) => (lang === LANG.FR ? elm.fr : elm.en))[0],
  country_id: countryList
    .filter((elm) => elm.id === branch?.country_id)
    .map((elm) => elm.name),
});
